import { Link } from 'react-router-dom'
import Layout from '../../components/layout/Layout'

const ThoughtCoreConcepts = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Understanding Core Concepts in Modern Web Graphics
        </h1>
        
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          A deep dive into the fundamental concepts that power modern web graphics and animations.
        </p>

        <div className="subline text-muted-foreground text-[0.875rem] leading-[1.2]">
          By{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Jean Mazouni
          </Link>{' '}
          in{' '}
          <Link to="#" className="text-foreground no-underline hover:underline">
            Tutorials
          </Link>{' '}
          on December 12, 2024
        </div>

        <div className="blog-body space-y-4 text-foreground text-[1.125rem] leading-[1.625] [text-wrap:balance]">
          <p>
            Before diving into the implementation, let's understand the key concepts that make this effect possible:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-foreground">
            <li>
              <span className="font-semibold">Signed Distance Functions (SDFs)</span>: Mathematical functions that return the shortest distance from a point to a shape's surface, with a sign indicating whether the point is inside or outside the shape.
            </li>
            <li>
              <span className="font-semibold">Canvas2D Context</span>: The rendering context that provides methods and properties for drawing and manipulating graphics on a canvas element.
            </li>
            <li>
              <span className="font-semibold">Morphing Animation</span>: The smooth transition between different shapes or states, achieved by interpolating between their parameters.
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  )
}

export default ThoughtCoreConcepts 